export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const triggerKeyword = node.data.triggerKeyword || ''

  let html = `<p class="card-text"><strong>Keywords</strong>: ${triggerKeyword}</p>`

  if (! triggerKeyword) {
    $('#hover-node-card .card-body').html('')
  } else {
    $('#hover-node-card .card-body').html(html)
  }

}